import { extractApiErrorMessage } from '@/lib/error-utils';

export const getBulkDeleteErrorMessage = (error: unknown) =>
  extractApiErrorMessage({
    data: error,
    fallbackMessage: 'Không thể xóa các dòng đã chọn. Vui lòng thử lại.'
  });
